import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import { FC } from 'react';
import { InvoiceReports as InvoiceReportsList } from './components/List';

export const InvoiceReports: FC = () => {
  const ffContext = useFFContext();
  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={ffContext}
        domain='ap-data-extraction-mismatch-alert'
      >
        <OpenFeatureProvider
          pollInterval={-1}
          context={ffContext}
          domain='ap-data-extraction-mismatch-alert-phase-2'
        >
          <InvoiceReportsList />
        </OpenFeatureProvider>
      </OpenFeatureProvider>
    </Wrapper>
  );
};
